import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puede acompañarme alguien durante SAINT®?",
    answer:
      "Sí. Los pacientes pueden traer a un acompañante. Como SAINT® se completa en cinco días, algunos pacientes viajan con un familiar o amigo. El equipo clínico puede ayudar a planificar la logística.",
  },
];

export const esCanSomeoneTravel = makeEsArticle({
  slug: "can-someone-travel-with-me-for-saint-tms",
  title: "¿Puede acompañarme alguien durante SAINT®?",
  description:
    "Sí. Los pacientes pueden traer a un acompañante durante la semana de SAINT®. El equipo clínico puede ayudar a planificar la logística del viaje.",
  h1: "¿Puede acompañarme alguien durante SAINT®?",
  breadcrumbLabel: "Acompañante en SAINT®",
  shortAnswer:
    "Sí. Los pacientes pueden traer a un acompañante durante la semana de SAINT®. Como el tratamiento se completa en cinco días consecutivos, algunos pacientes viajan con un familiar o amigo que les acompaña a la clínica. El equipo clínico puede ayudar a planificar la logística del viaje y la estancia. SAINT® se administra sin anestesia, por lo que el paciente puede generalmente conducir o desplazarse con su acompañante cada día.",
  keyTakeaways: [
    "Los pacientes pueden traer a un acompañante.",
    "Algunos viajan con un familiar o amigo.",
    "El equipo clínico ayuda a planificar la logística.",
    "SAINT® se completa en cinco días consecutivos.",
    "El paciente puede generalmente desplazarse con su acompañante.",
  ],
  sections: [
    {
      heading: "Acompañantes",
      paragraphs: [
        "Los pacientes pueden traer a un acompañante durante la semana de SAINT®. Como el tratamiento se completa en cinco días consecutivos en lugar de varias semanas, algunos pacientes viajan con un familiar o amigo. El equipo clínico puede ayudar a planificar la logística del viaje y la estancia.",
        "[[Consulte nuestra guía de viaje|/es/saint-tms-travel]] para pacientes que se desplazan a Coral Springs.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
